/**
 * Web stand-in for PartnerOfferSheet.native.tsx (partner codes build item 5 / C5).
 *
 * The web app sells nothing, so the sheet never shows there (usePartnerOfferGate answers
 * `none` off a phone). If anything renders it anyway, it hands the open straight back to
 * the normal paywall. Keeps react-native-purchases out of the web bundle.
 */
import { useEffect } from 'react';
import type { PartnerPeriod, PartnerPurchaseOffer } from '@/utils/partnerOfferSheet';

export interface PartnerOfferSheetProps {
  offer: PartnerPurchaseOffer;
  userId: string | null;
  onPurchased: (tier: 'basic' | 'full' | 'extended' | null, period: PartnerPeriod) => void;
  onSeeAllPlans: () => void;
  onNotNow: () => void;
  onDecline?: () => void;
}

export function PartnerOfferSheet({ onSeeAllPlans }: PartnerOfferSheetProps) {
  useEffect(() => { onSeeAllPlans(); }, [onSeeAllPlans]);
  return null;
}

export default PartnerOfferSheet;
